export default __webpack_public_path__ + "static/media/03.aa1f5730.jpg";